<template>
    <div class="animated fadeIn">
        <DynamicList
                ref="dynamicCardList"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                :onRetrieve="onRetrieve"
                root="/report/commerce-tickets-2"
                :searchArgs="searchArgs">

            <slot slot="afterSearchForm">
                <b-button @click="$refs.modalExport.open = true" variant="light" class="mb-3">
                    {{Core.Definition.getDefinition("Exporter sous format ...")}}
                </b-button>
                <ModalExport
                        ref="modalExport"
                        root="/report/commerce-tickets-2"
                        :formStructure="{
                                rows: [
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportFormat'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                     {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'firstname'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'lastname'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'teamTitle'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'participantCategoryTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'tshirtSize'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'tshirtCustomName'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                           {
                                                fields: [
                                                    {
                                                        id: 'seasonTitle'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'ticketNumber'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'urgencyContact'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'urgencyPhone'
                                                    }
                                                ]
                                            }
                                        ]
                                    },

                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'leagueTitle'
                                                    }
                                                ]
                                            },
                                             {
                                                fields: [
                                                    {
                                                        id: 'eventDate'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'address'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'productTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'code'
                                                    }
                                                ]
                                            },
                                            {

                                            }
                                        ]
                                    }

                                ],
                                fields: [
                                    {
                                        id: 'exportFormat',
                                        type: 'select',
                                        options: Core.Export.formatOptions(),
                                        label: Core.Definition.getDefinition('Format'),
                                        value: null,
                                        onSelect: function() {}
                                    },
                                    {
                                        id: 'exportTitle',
                                        type: 'text',
                                        label: Core.Definition.getDefinition('Titre'),
                                        value: '',
                                        required: true
                                    },

                                    {
                                        id: 'firstname',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Prénom'),
                                        value: true,
                                         export: 'firstname',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'lastname',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Nom de famille'),
                                        value: true,
                                         export: 'lastname',
                                        onChange: function() {}
                                    },

                                    {
                                        id: 'tshirtSize',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Taille T-Shirt'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'tshirtSize',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'tshirtCustomName',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Nom personnalisé'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'tshirtCustomName',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'urgencyContact',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Contact d\'urgence'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'urgencyContact',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'urgencyPhone',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Téléphone d\'urgence'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'urgencyPhone',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'insuranceNumber',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Assurance maladie'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'insuranceNumber',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'ticketNumber',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Numéro de billet'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'ticketNumber',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'teamTitle',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Nom équipe'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'teamTitle',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'participantCategoryTitle',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Nom catégorie'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'participantCategoryTitle',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'leagueTitle',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Ligue'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'leagueTitle',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'seasonTitle',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Saison'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'seasonTitle',
                                        onChange: function() {}
                                    },

                                    {
                                        id: 'eventDate',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Date'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'eventDate',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'address',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Adresse'),
                                        value: true,
                                         export: 'address',
                                        onChange: function() {}
                                    },
                                     {
                                        id: 'productTitle',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Nom de produit'),
                                        value: true,
                                         export: 'productTitle',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'code',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Code promo'),
                                        value: true,
                                         export: 'code',
                                        onChange: function() {}
                                    },
                                ]}"
                @onSubmit="onExport">
                </ModalExport>
            </slot>
        </DynamicList>
    </div>
</template>

<script>
    import DynamicList from '../../../../components/DynamicList'
    import ModalExport from '../../../../components/ModalExport'
    import ChartPie from '../../../../components/ChartPie'
    export default {
        name: 'ReportCommerceTicket',
        components: {
            DynamicList,
            ModalExport,
            ChartPie
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataSearchArgs: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('Billet'),
                        key: 'ticketNumber',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Prénom'),
                        key: 'firstname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom'),
                        key: 'lastname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Équipe'),
                        key: 'teamTitle',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Catégorie'),
                        key: 'participantCategoryTitle',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('T-Shirt'),
                        key: 'tshirtSize',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom perso.'),
                        key: 'tshirtCustomName',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Produit'),
                        key: 'title',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Saison'),
                        key: 'seasonTitle',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Ligue'),
                        key: 'leagueTitle',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date'),
                        key: 'eventDate',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Code promo'),
                        key: 'code',
                        sortable: false
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'ticketNumber'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'start'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'end'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'purchaseId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'firstname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'lastname'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'teamId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'productId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'seasonId'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'categoryId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'leagueId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'branchId'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'email'
                                        }
                                    ]
                                },
                                {},
                                {}
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'email',
                            type: 'text',
                            label: Core.Definition.getDefinition('Courriel'),
                        },
                        {
                            id: 'start',
                            type: 'date',
                            label: Core.Definition.getDefinition('Début'),
                        },
                        {
                            id: 'end',
                            type: 'date',
                            label: Core.Definition.getDefinition('Fin'),
                        },
                        {
                            id: 'ticketNumber',
                            type: 'text',
                            label: Core.Definition.getDefinition('# billet'),
                        },
                        {
                            id: 'firstname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Prénom'),
                            value: ''
                        },
                        {
                            id: 'lastname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Nom de famille'),
                            value: ''
                        },
                        {
                            id: 'purchaseId',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID achat'),
                            value: ''
                        },
                        {
                            id: 'productId',
                            type: 'multiSelect',
                            label: Core.Definition.getDefinition('Produit'),
                            value: null,
                            onSelect: function() {
                            }
                        },
                        {
                            id: 'seasonId',
                            type: 'multiSelect',
                            label: Core.Definition.getDefinition('Saison'),
                            value: null,
                            onSelect: function() {
                            }
                        },
                        {
                            id: 'categoryId',
                            type: 'multiSelect',
                            label: Core.Definition.getDefinition('Catégorie'),
                            value: null,
                            onSelect: function() {
                            }
                        },
                        {
                            id: 'teamId',
                            type: 'multiSelect',
                            label: Core.Definition.getDefinition('Équipe'),
                            value: null,
                            onSelect: function() {
                            }
                        },
                        {
                            id: 'leagueId',
                            type: 'multiSelect',
                            isVisible: Core.Session.AuthUser.can('report_multiple_league'),
                            label: Core.Definition.getDefinition('Ligue'),
                            value: null,
                            onSelect: function() {
                            }
                        },
                        {
                            id: 'branchId',
                            type: 'multiSelect',
                            isVisible: Core.Session.AuthUser.can('report_multiple_branch') && Core.Session.isPrimaryBranch() ,
                            label: Core.Definition.getDefinition('Établissement'),
                            value: null,
                            onSelect: function() {
                            }
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataCharts: false,
                dataSelectOptions: {}
            }
        },
        methods: {
            onExport() {
                let searchArgs = this.$refs.dynamicCardList.$refs.request.dataArgs
                for(let searchArg in searchArgs) {
                    searchArg = searchArgs[searchArg]
                    this.$refs.modalExport.$refs.request.addArg(searchArg.key, searchArg.value, searchArg.type)
                }
            },
            onRetrieve(data) {
              if(data !== undefined) {
                  if (data.charts !== undefined) {
                      this.dataCharts = data.charts
                  }
                  if (data.selectOptions !== undefined) {
                      this.dataSelectOptions = data.selectOptions
                  }
              }
            },
            clickEdit(value, cell, row) {
                this.$router.push('/commerce/commandes/' + row.purchaseId)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
